<template>
  <div class="get_stamp">
    <div class="dimmer"></div>
    <div class="body">
      <div class="main">
        <div class="title">ウォークスタンプを<br />GETしました！</div>
        <img src="@/assets/img/walk/walk-get.png" />
        <div class="message">
          オリジナルスタンプ獲得！<br />スタンプ画面でチェックしよう
        </div>
      </div>
      <div class="footer" @click="close">
        <div class="button">閉じる</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WalkTop',
  props: {},
  data: function() {
    return {}
  },
  async created() {
    document.title = 'ウォーク'
  },
  mounted: function() {},
  computed: {},
  watch: {},
  methods: {
    close: function() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.get_stamp {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .dimmer {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(51, 51, 51, 0.9);
  }
  .body {
    z-index: 1;
    border-radius: 10px;
    background-color: #f5f5f5;
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    font-weight: bold;
    font-size: 4vw;
    animation-name: fadein;
    animation-duration: 0.2s;

    .main {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      flex-grow: 1;
      padding: 20px 0;
      .title {
        font-size: 5vw;
        margin: 10px 0;
      }
      img {
        width: 100%;
      }
      border-bottom: 1px solid #cccccc;
      .message {
        margin: 10px 0;
      }
    }
    .footer {
      text-align: center;
      margin: 15px 0;
      color: #64290f;
    }
  }
}
@keyframes fadein {
  from {
    transform: scale(0.9);
    opacity: 0.3;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
